<template src="./Settings.html"></template>

<script>
import sitesTopMenu from "@/components/sites/components/topMenu"
import LanguagesSelect from "@/components/components/LanguagesSelect"
import {createNamespacedHelpers} from 'vuex'
import BrandSelect from "@/components/components/BrandSelect"
import BrandTagSelect from "@/components/components/BrandTagSelect"
import Multiselect from 'vue-multiselect'
import ClientCountrySelect from '@/components/components/ClientCountrySelect';

const {mapGetters, mapActions} = createNamespacedHelpers('sites/settings')

export default {
  name: "Indexing",
  components: {
    sitesTopMenu,
    Multiselect,
    BrandSelect,
    BrandTagSelect,
    ClientCountrySelect,
    LanguagesSelect,
  },
  data() {
    return {
      showOverlay: false,
      brandSelectUpdate: true,
      currentSiteId: this.$route.params.id,
    }
  },
  methods: {
    ...mapActions([
      'GET_INDEXING_STATUS',
      'GET_DATA',
      'GET_GROUPS',
      'GET_YANDEX_REGIONS',
      'GET_GOOGLE_REGIONS',
      'SAVE',
    ]),
    save: function () {
      this.SAVE({th: this})
    },
    languagesChange(lang) {
      this.DATA.language = lang
    },
    brandsChange: function (brands) {
      // remove 'Все' if exist other
      if (brands.length > 1) {
        for (let key in brands) {
          if (brands[key] === 'Все') {
            brands.splice(key, 1)
            break
          }
        }
      }
      this.DATA.brands = brands
    },
    brandsChangeAll: function () {
      this.brandSelectUpdate = false
      this.$set(this.DATA, 'brands', ['Все'])
      this.$nextTick(() => {
        this.brandSelectUpdate = true
      })
    },
    tagsChange: function (tags) {
      this.DATA.tags = tags
    },
  },
  computed: {
    ...mapGetters([
      'DOMAIN',
      'DATA',
      'GROUPS',
      'YANDEX_REGION_LIST',
      'GOOGLE_REGION_LIST',
      'SITE_LIST'
    ]),
    isEmptyOfData() {
      return Object.keys(this.DATA).length === 0
    },
    getGroupOptions: function () {
      let groupOptions = [{value: 'н/д', text: 'н/д'}]
      for (let key in this.GROUPS) {
        let val = this.GROUPS[key]
        groupOptions.push({value: val.name, text: val.name})
      }

      return groupOptions
    },
  },
  mounted() {
  },
  created() {
    if (this.$store.getters.getAllowSection.indexOf('sites') === -1) {
      this.$router.push({name: 'permissionDenied'})
      return
    }

    this.$store.commit('sites/settings/CURRENT_SITE_ID', this.currentSiteId)

    if (this.isEmptyOfData || this.currentSiteId != this.DATA.id) {
      this.GET_DATA({th: this})
    }
    if (this.GROUPS.length === 0) {
      this.GET_GROUPS({th: this})
    }
    if (this.YANDEX_REGION_LIST.length === 0) {
      this.GET_YANDEX_REGIONS({th: this})
    }
    if (this.GOOGLE_REGION_LIST.length === 0) {
      this.GET_GOOGLE_REGIONS({th: this})
    }
  },
  watch: {
    currentSiteId(newVal) {
      // this.chartName = ''
      this.$store.commit('sites/settings/CURRENT_SITE_ID/CURRENT_SITE_ID', newVal);
      this.GET_DATA({th: this})
    },
  },
}
</script>

<style scoped>
.text-left {
  text-align: left;
}
.but-save {
  position:-webkit-sticky;
  position: sticky;
  top: 2em;
  z-index: 50;
}
.but-shadow {
  box-shadow: 5px 5px 30px 5px grey;
}
.submit-button {
  text-align: right;
}
.iframe {
  width: 100%;
  border: 0;
}
</style>

<style>

</style>